export const woonenergieNavlinkOncolorColors = {
  navLinkSecondaryOnColorDefault: '{{ neutralColors.neutral200 }}',
  navLinkSecondaryOnColorHover: '{{ neutralColors.neutralWhite }}',
  navLinkSecondaryOnColorFocusOutline: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorDefault: '{{ neutralColors.neutral200 }}',
  navLinkTertiaryOnColorHover: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorFocusOutline: '{{ neutralColors.neutralWhite }}',
};

export const navLinkStyledTextUnderline = {
  styledTextUnderline: `100% 2px`,
};
